import { MasterModuleLayout, useMasterModule } from "../Common";
import { useGetData, useToggleStatusMutation } from "@/services";

const PropertyCategory = () => {
  const masterHook = useMasterModule({
    queryKey: "property-categories",
    idKey: "categoryId",
    nameKey: "categoryName",
    useGetDataQuery: useGetData,
    useToggleStatusMutation: useToggleStatusMutation,
    module: "property-categories",
    statusSuccessMessage: "Property Category Status Updated Successfully",
  });

  return <MasterModuleLayout title="Property Category" hookResult={masterHook} />;
};

export default PropertyCategory;
